<template>
  <div>

    <template v-if="isBottom">
      <button
          @click="displayFeedback = true"
          class="
          focus:outline-none
          text-lg
          hover:bg-yellow-200
          font-bold
          text-black
          shadow-xl
          rounded-full
          p-4
          bg-yellow-300
          fixed
          bottom-5
          right-10
          z-50
        "
      >
        😋 Feedback
      </button>
    </template>

    <template v-if="isBottom === false">
      <button
          @click="displayFeedback = true"
          class="
          focus:outline-none
          text-lg
          hover:bg-yellow-200
          font-bold
          text-black
          rounded-full
          p-2
          bg-yellow-300
          z-50
        "
      >
        😋 Feedback
      </button>
    </template>

    <dialog-modal
        @close="displayFeedback = false"
        :show.sync="displayFeedback"
    >
      <template #title>
        <div class="text-2xl font-bold font-black">
          Thank you for sharing your experience! ^.^
        </div>
      </template>

      <template #content>
        <div class="w-full">
          <div class="px-5 pt-7 pb-2">
            <label class="font-semibold">Rate Us 👉🏽 : </label>
            <a-rate v-model:value="feedbackRate" class="text-2xl"/>

            <label class="block">
                <textarea
                    v-model="feedbackContent"
                    class="
                    h-60
                    text-md
                    form-input
                    border-gray-200 border-2
                    rounded-lg
                    px-3
                    py-3
                    mt-1
                    mb-5
                    text-sm
                    w-full
                  "
                    placeholder="Something can be improved or something is really good."
                />
            </label>

            <a-spin :spinning="submittingFeedback">
              <button
                  @click.prevent="submitFeedback"
                  type="button"
                  class="
                    rounded-full
                    transition
                    duration-200
                    bg-yellow-400
                    hover:bg-yellow-300
                    focus:outline-none
                    text-black
                    w-full
                    py-2.5
                    rounded-lg
                    text-lg
                    font-semibold
                    text-center
                    inline-block
                  "
              >
                <span class="inline-block mr-2">Submit your feedback</span>
              </button>
              <small>You can also contact us via<a class="text-blue-500 font-bold"
                                                   href="mailto:support@agilesuite.io">
                support@agilesuite.io</a>.</small>
            </a-spin>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="text-md text-blue-500 font-bold inline-block ml-1">
          agilesuite.io
        </div>
        <!--                <secondary-button @click="isRegisteredClicked = false">Close</secondary-button>-->
      </template>
    </dialog-modal>

  </div>

</template>

<script>


import DialogModal from "@/Jetstream/DialogModal";

import {message} from "ant-design-vue";

export default {
  props: {
    topic: {},
    isBottom: {
      default: true
    }
  },
  setup() {

    return {}
  },
  data() {
    return {
      submittingFeedback: false,
      displayFeedback: false,
      feedbackRate: 3,
      feedbackContent: null,
    };
  },
  mounted() {
  },
  methods: {
    submitFeedback() {
      let app = this;
      app.submittingFeedback = true;
      axios
          .post(route("planning-rooms.feedback", {id: app.topic}), {
            rate: this.feedbackRate,
            content: this.feedbackContent,
            topic: app.topic,
          })
          .then((response) => {
            // app.moderator = value;
            app.displayFeedback = false;
            message.success("Thank you for sharing your feedback.", 5);
            app.submittingFeedback = false;
          })
          .catch((error) => {
            message.error(
                "You attempted too many times or we experience an error.",
                5
            );
            app.submittingFeedback = false;
          });
    },
  },

  components: {
    message,
    DialogModal,
  },
};
</script>
